import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

import { dtmConst } from '..';

export const getTests = (blockId?: string) => async () => {
  const { data } = await $apiV2.get<{ data: any[] }>(`/dtm/blocks/${blockId}/collections`);

  return { tests: data.data };
};

export const useTests = ({ blockId }: { blockId?: string }) => {
  const { data, ...args } = useQuery({
    queryKey: [dtmConst.queryKeys.DTM_COLLECTIONS, blockId],
    queryFn: getTests(blockId),
    refetchOnMount: true
  });

  return { ...data, ...args };
};
